<template>
  <div class="fill-height of-y">
    <v-row
        no-gutters
        class="of-y fill-height"
    >
      <v-col class="fill-height of-y grey lighten-5 d-flex" cols="3">
        <div class="fill-height d-flex flex-column of-y flex-grow-1">
          <div class="sub--text primary pl-3 pr-2">
            Select Farm
          </div>
          
          <div class="flex-grow-1 of-y">
            <multi-select-list
                :items="availableFarms"
                itemKey="id"
                :showCheckBoxes="true"
                :multiple="false"
                headlineKey="description"
                sub-line-key="farmDescription"
                v-model="selectedFarmID"
                filterLabel="Filter Farms"
            >
              <template #header>
                <div class="pa-2">
                  <v-btn
                      :disabled="false"
                      @click="exportBlockData"
                      color="primary"
                      small
                      :loading="exportingData"
                      block
                  >
                    Export Blocks
                  </v-btn>
                </div>
              </template>
            </multi-select-list>
          </div>
        </div>
        
        <divider color="primary darken-1" :vertical="true"/>
      </v-col>
      
      
      <v-col class="fill-height of-y d-flex" cols="3" v-if="!!selectedFarmID">
        <div class="fill-height d-flex flex-column of-y flex-grow-1">
          <div class="primary pl-3 pr-2 pa-2 sub--text">
            Select Block
          </div>
          
          <div class="flex-grow-1 of-y">
            <multi-select-list
                :items="disabledFilter"
                itemKey="id"
                :showCheckBoxes="true"
                :multiple="false"
                headlineKey="blockDescription"
                sub-line-key="varietyDescription"
                v-model="selectedBlockID"
                filterLabel="Filter Blocks"
            >
              <div slot="header" class="px-2 pt-2">
                <v-btn
                    small
                    block
                    color="primary"
                    @click="showDisabled = !showDisabled"
                    class="mb-2"
                >
                  {{!showDisabled ? 'Show' : 'Hide'}} Disabled
                </v-btn>
                <v-btn
                    small
                    block
                    color="primary"
                    @click="importBlockShow = !importBlockShow"
                    class="mb-2"
                >
                  <v-icon left>mdi-application-import</v-icon>
                  Import Blocks
                </v-btn>
                <v-btn
                    small
                    block
                    color="primary"
                    class="my-2"
                    @click="batchDisableShow = !batchDisableShow"
                >
                  <v-icon left>mdi-account-remove</v-icon>
                  Batch Disable
                </v-btn>
                <batch-disable-block v-if="batchDisableShow" v-model="batchDisableShow" :fk-farm="selectedFarmID"/>
                <v-btn
                    small
                    block
                    color="primary"
                    @click="createBlockShow = !createBlockShow"
                >
                  <v-icon left>mdi-tree-outline</v-icon>
                  Add Block
                </v-btn>
              </div>
            </multi-select-list>
          </div>
        </div>
        <divider color="primary darken-1" :vertical="true"/>
      </v-col>
      
      <v-col class="fill-height of-y pa-2" cols="6" v-if="!!selectedBlock">
        <v-card>
          <ModifyBlock :edit-block="selectedBlock" @save="upsertBlock($event)"/>
        </v-card>
        
        <v-card class="mt-2">
          <div class="primary d-flex align-center">
            <div class="flex-grow-1 primary pl-3 pr-2 sub--text">
              {{ selectedBlock.description }} Barcodes
            </div>
          </div>
          <v-divider></v-divider>
          <manage-barcodes ref-key="fkBlock" :ref-val="selectedBlock.id"/>
        </v-card>
      
      </v-col>
      <v-dialog
          v-if="createBlockShow"
          v-model="createBlockShow"
          :width="400"
          persistent
      >
        <v-card>
          <ModifyBlock :edit-block="createBlockObj" @dismiss="createBlockShow = !createBlockShow"
                       @save="upsertBlock($event)"/>
        </v-card>
      </v-dialog>
    </v-row>
    
    <import-block v-if="importBlockShow" v-model="importBlockShow" :selected-farm="selectedFarmID"/>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyBlock from "./ModifyBlock";
import {waitForEvent} from "../../../core/socket";
import Divider from "../../General/Divider";
import ManageBarcodes from "../Manage Barcodes/ManageBarcodes";
import ImportBlock from "./Import/ImportBlock";
import {format} from "date-fns";
import BatchDisableBlock from "@/components/Setup/Blocks/BatchDisableBlock.vue";

export default {
  components: {
    BatchDisableBlock,
    ImportBlock,
    ManageBarcodes,
    Divider,
    ModifyBlock,
    MultiSelectList
  },
  props: {},
  data() {
    return {
      selectedFarmIndex: null,
      selectedFarmID: null,
      selectedBlockID: null,
      createBlockObj: null,
      createBlockShow: false,
      importBlockShow: false,
      exportingData: false,
      batchDisableShow: false,
      showDisabled: false
    }
  },
  watch: {
    createBlockShow(val) {
      if (val)
        this.createBlockObj = {
          id: null,
          description: null,
          fkFarm: this.selectedFarmID,
          fkVariety: null
        }
    }
  },
  methods: {
    exportBlockData() {
      this.exportingData = true;
      this.$newReqDownloadFile(
          'POST',
          `reports/blocks/export`,
          {},
          `Blocks Export ${format(new Date(), 'MM-dd')}.xlsx`
      )
          .then(data => {
            console.log(data)
          })
          .catch(e => {
            console.log(e)
            this.$snack.netWorkError();
          })
          .finally(() => {
            this.exportingData = false
          })
    },
    async upsertBlock(event) {
      let {block, ref} = event;
      ref.loading = true;
      try {
        const eventID = await this.$newReq('POST', `setup/block`, block)
        const addedBlock = (await waitForEvent(eventID)).blocks.pop()
        this.createBlockShow = false
        this.selectedFarmID = addedBlock.fkFarm;
        this.selectedBlockID = addedBlock.id;
        this.$snack.info('Changes saved')
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        ref.loading = false
      }
    }
  },
  computed: {
    ...mapGetters(['farms', 'availableFarms']),
    
    selectedFarm() {
      if (!this.selectedFarmID)
        return null
      return this.farms.filter(obj => obj.id === this.selectedFarmID).pop()
    },
    
    selectedBlock() {
      if (!this.selectedBlockID)
        return null
      return this.selectedFarm.blocks.filter(obj => obj.id === this.selectedBlockID).pop()
    },
    
    disabledFarms() {
      const availableFarmsArr = this.availableFarms.map(obj => obj.id)
      return this.farms.map(farm => {
        return {
          ...farm,
          disabled: !availableFarmsArr.includes(farm.id)
        }
      })
    },
    disabledFilter() {
      return this.selectedFarm.blocks.filter(v => !!v.disabled === this.showDisabled)
    }
  },
}
</script>

<style scoped>

</style>